import { mainSiteUrl } from '@/data/categories';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[680px] md:min-h-[780px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20retail%20concept%20with%20warm%20terracotta%20and%20olive%20green%20tones%2C%20artistic%20display%20of%20contemporary%20streetwear%20including%20designer%20sneakers%20hoodies%20and%20accessories%20floating%20in%20a%20dreamy%20soft%20focus%20composition%2C%20gentle%20diffused%20window%20light%20creating%20warm%20atmosphere%2C%20modern%20scandinavian%20boutique%20aesthetic%20with%20natural%20linen%20textures%20and%20organic%20shapes%2C%20editorial%20fashion%20photography%20with%20sophisticated%20minimal%20styling%20and%20harmonious%20color%20palette%20of%20sage%20amber%20and%20cream&width=1600&height=900&seq=hero-kakobuy-v2-2026&orientation=landscape"
          alt="Kakobuy Spreadsheet Polska - Najlepsza baza produktów"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 text-xs md:text-sm mb-6">
          <i className="ri-sparkling-line"></i>
          <span>Aktualizacja 2026 – Nowe produkty dodane!</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
          Kakobuy Spreadsheet Polska
          <br />
          <span className="text-primary-300">Najlepsza Baza Produktów Kakobuy</span>
        </h1>

        <p className="text-white/75 text-sm md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          Odkrywaj najlepsze produkty z Chin dzięki aktualizowanemu Kakobuy Spreadsheet.
          Znajduj sneakersy, ubrania, akcesoria i sprawdzone linki w jednym miejscu.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href="#categories"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white font-semibold text-sm rounded-full hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/20"
          >
            <i className="ri-search-line mr-2"></i>
            Przeglądaj Kakobuy Spreadsheet
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 text-white font-semibold text-sm rounded-full hover:bg-accent-600 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-shopping-bag-line mr-2"></i>
            Buy It Now
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 text-white/70">
          <div className="flex items-center gap-2 text-xs md:text-sm">
            <i className="ri-checkbox-circle-line text-accent-400 text-base"></i>
            <span>Aktualne informacje</span>
          </div>
          <div className="flex items-center gap-2 text-xs md:text-sm">
            <i className="ri-checkbox-circle-line text-accent-400 text-base"></i>
            <span>Poradniki dla Polski</span>
          </div>
          <div className="flex items-center gap-2 text-xs md:text-sm">
            <i className="ri-checkbox-circle-line text-accent-400 text-base"></i>
            <span>Porównania produktów</span>
          </div>
          <div className="flex items-center gap-2 text-xs md:text-sm">
            <i className="ri-checkbox-circle-line text-accent-400 text-base"></i>
            <span>Bezpieczne zakupy</span>
          </div>
        </div>
      </div>
    </section>
  );
}